export default {
	"BASE_URL": "https://api.contestcrate.com/"
};
